module.exports = __webpack_public_path__ + "static/media/image4.60f99a4d.png";